import styled from 'styled-components';
import checked from 'assets/img/checked.svg';

export const ContainerStyled = styled.div`
    margin-left: 24px;
    
    input {
        display: none;
    }

    label {
        cursor: pointer;
    }
`;

export const ShadowAroundStyled = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    top: -3px;
    left: -6px;
    border-radius: 50%;
    width: 24px;
    height: 24px;

    &:hover {
        background-color: rgba(160, 167, 176, 0.32);
        transform: translate(-2%, -2%);
    }
 
`;

export const LabelStyled = styled.label`
    display: flex;
    align-items: center;
    position: relative;
    color: #343A40;
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
    letter-spacing: -0.4px;
    margin: 0;
    gap: 1px;
    
    span.link-termos-uso {
        font-weight: 600;
        text-decoration: underline;
        margin-left: 4px;
    }
`;

export const SquareStyled = styled.span<{
    isChecked: boolean;
}>`
    margin-right: 8px;
    display: flex;
    width: 12px;
    height: 12px;
    border: 1px solid #343A40;
    border-radius: 1px;
    background: ${({ isChecked }) => isChecked ? `url(${checked}) no-repeat right` : 'transparent'};
    
`;